import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PortalButtonsComponent} from "./components/portal-buttons/portal-buttons.component";
import {PortalInfiniteScrollComponent} from "./components/portal-infinite-scroll/portal-infinite-scroll.component";
import {PortalDynamicModule} from "./components/portal-dynamic/components/portal-dynamic.module";
import {PortalPageModule} from "./portal-page.module";
import {PortalSearchModule} from "./components/portal-search/portal-search.module";
import { PortalListComponent } from './components/portal-list/portal-list.component';
import { PortalControlsComponent } from './components/portal-controls/portal-controls.component';
import {RouterModule} from "@angular/router";
import { PortalChartComponent } from './components/portal-chart/portal-chart.component';
import {HighchartsChartModule} from "../../highcharts/highcharts-chart.module";
import {CoreModule} from "../../core/core.module";
import {SharedModule} from "../../shared/shared.module";
import {DropDownButtonAllModule, SplitButtonAllModule} from "@syncfusion/ej2-angular-splitbuttons";

@NgModule({
  imports: [
    CommonModule,
    PortalDynamicModule,
    PortalPageModule,
    PortalSearchModule,
    RouterModule,
    HighchartsChartModule,
    CoreModule,
    SharedModule,
    SplitButtonAllModule,
    DropDownButtonAllModule,
  ],
  declarations: [
    PortalButtonsComponent,
    PortalInfiniteScrollComponent,
    PortalListComponent,
    PortalControlsComponent,
    PortalChartComponent,
  ],
  exports: [
    PortalButtonsComponent,
    PortalInfiniteScrollComponent,
  ]
})
export class PortalComponentsModule { }
